<template>
  <div class="browser-page">
    <div class="browser-card">
      <div class="browser-icon-wrap">
        <svg class="browser-ok-icon" viewBox="0 0 64 64" width="56" height="56">
          <circle cx="32" cy="32" r="30" fill="#e8f5e9" />
          <circle cx="32" cy="32" r="20" fill="#4caf50" />
          <path d="M24 32l6 6 10-12" fill="none" stroke="#fff" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
      <h2 class="browser-title">浏览器兼容性提醒</h2>
      <p class="browser-desc">为了更好的用户体验及您的信息安全，建议使用以下浏览器进行上课</p>
      <div class="browser-list">
        <div class="browser-item">
          <img class="browser-icon-img" src="https://img0.baidu.com/it/u=630637352,2479023404&fm=253&fmt=auto&app=138&f=PNG?w=500&h=500" alt="360" />
          <span class="browser-name">360 浏览器</span>
        </div>
        <div class="browser-item">
          <img class="browser-icon-img" style="margin: 4px; width: 36px; height: 36px" src="https://bizaladdin-image.baidu.com/0/pic/-1348861975_1345754776_1245016489.png" alt="chrome" />
          <span class="browser-name">Google 浏览器</span>
        </div>
        <div class="browser-item">
          <img class="browser-icon-img" style="margin: 4px; width: 36px; height: 36px" src="https://bizaladdin-image.baidu.com/0/pic/155463109_1578872040_-69067908.png" alt="360" />
          <span class="browser-name">Edge 浏览器</span>
        </div>
        <div class="browser-item">
          <img class="browser-icon-img" src="https://img1.baidu.com/it/u=1379104621,124224536&fm=253&fmt=auto&app=120&f=PNG?w=380&h=380" alt="safari" />
          <span class="browser-name">Safari 浏览器</span>
        </div>
        <div class="browser-item">
          <img class="browser-icon-img" src="https://img1.baidu.com/it/u=2735514046,3299700474&fm=253&fmt=auto&app=138&f=PNG?w=273&h=273" alt="safari" />
          <span class="browser-name">华为 浏览器</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BrowserDetect'
};
</script>

<style scoped>
.browser-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e9f2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.browser-card {
  background: #fff;
  border-radius: 16px;
  padding: 40px 32px;
  max-width: 480px;
  width: 100%;
  text-align: center;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  margin: 20px;
}

.browser-icon-wrap {
  margin-bottom: 16px;
}

.browser-ok-icon {
  display: inline-block;
}

.browser-title {
  font-size: 20px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 12px;
}

.browser-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.8;
  margin: 0 0 32px;
}

.browser-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.browser-item {
  display: flex;
  align-items: center;
  background: #f8f9fc;
  border-radius: 12px;
  padding: 14px 16px;
}

.browser-item:hover {
  background: #eef0ff;
}

.browser-icon-img {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  flex-shrink: 0;
  object-fit: contain;
}

.browser-name {
  flex: 1;
  text-align: left;
  margin-left: 14px;
  font-size: 15px;
  font-weight: 500;
  color: #1a1a2e;
}
</style>
